import React, { useState } from 'react';
import Icon from '../Icon';
import { CarouselContainer, CarouselControlsContainer, CarouselLabel, CarouselStyled, StepperStyled, } from './Carousel.styles';
const Carousel = ({ items, labelProps, variant, startingIndex, eventHandler = () => null, ...props }) => {
    let startIndex = startingIndex || 0;
    if (startIndex < 0 || startIndex >= items.length) {
        console.warn(`startingIndex [${startIndex}] is out of range. \
			Value should be between 0 and ${items.length}. Resetting startingIndex to 0.`);
        startIndex = 0;
    }
    const [activeStep, setActiveStep] = useState(startIndex);
    const maxSteps = items.length;
    const handlePrevious = () => {
        eventHandler({
            event: 'arrow',
            value: 'previous',
        });
        handleStep(-1);
    };
    const handleNext = () => {
        eventHandler({
            event: 'arrow',
            value: 'next',
        });
        handleStep(1);
    };
    const handleStep = (stepSize) => {
        let nextStep = activeStep + stepSize;
        nextStep = (nextStep % items.length + items.length) % items.length;
        setActiveStep(nextStep);
    };
    // when using mouse to swipe on items, determine which direction the swipe was so either step forward or back.
    const handleStepChange = (step, indexLatest) => {
        handleStep(step > activeStep ? 1 : -1);
    };
    const SlideRenderer = ({ index, key, }) => {
        var _a;
        return (React.createElement("div", { key: key }, (_a = items.at(index % items.length)) === null || _a === void 0 ? void 0 : _a.component));
    };
    const { label, } = items[activeStep];
    return (React.createElement(CarouselContainer, null,
        React.createElement(CarouselStyled, { animateTransitions: false, slideRenderer: SlideRenderer, index: activeStep, onChangeIndex: handleStepChange, disabled: maxSteps <= 1, ...props }),
        React.createElement(CarouselControlsContainer, null,
            maxSteps > 1 &&
                React.createElement(Icon, { size: "l", name: 'arrow-left', onClick: handlePrevious }),
            React.createElement(CarouselLabel, { ...labelProps }, label),
            maxSteps > 1 &&
                React.createElement(Icon, { size: "l", name: 'arrow-right', onClick: handleNext })),
        maxSteps > 1 &&
            React.createElement(StepperStyled, { steps: maxSteps, position: "static", activeStep: activeStep, backButton: false, nextButton: false, variant: variant })));
};
export default Carousel;
//# sourceMappingURL=Carousel.js.map